import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'relocation' })
export class RelocationPipe implements PipeTransform {

  constructor() {}

  transform(value: any, ...args: any[]): any {
    if (value === false) { return 'Not prefered'; }
    if (value === true) { return 'Possible'; }
    return 'Not prefered'
  }

}
